import { IFramePlayerAbstractClass } from 'iframe/ts/player/abstract/IFramePlayerAbstractClass';
import { IFramePlayerEvent } from 'iframe/ts/player/events/IFramePlayerEvent';
import { IFramePlayerErrorCode } from 'iframe/ts/player/model/error/IFramePlayerErrorCode';
import { IFramePlayerErrorFatal } from 'iframe/ts/player/model/error/IFramePlayerErrorFatal';
import { IFramePlayerErrorInfo } from 'iframe/ts/player/model/error/IFramePlayerErrorInfo';
import { IFramePlayerConstants } from 'iframe/ts/player/model/IFramePlayerConstants';
export class IFrameDependenciesLoader extends IFramePlayerAbstractClass {
    constructor(iframePlayer) {
        super(iframePlayer, 'IFrameDependenciesLoader');
        this.appEventsHandler(this.#onAppEvent, [
            IFramePlayerEvent.ON_SMART_TAG_IMPORT_REQUEST,
            IFramePlayerEvent.ON_UTAG_IMPORT_REQUEST
        ]);
    }
    #loadUtag = () => {
        this.utils.Importer.import([IFramePlayerConstants.getInstance().utagImportVO], true).then((data) => {
            this?.logger?.log('loadUtag:', 'load utag success!', data);
            this.dispatchIFramePlayerEvent({
                type: IFramePlayerEvent.ON_UTAG_IMPORT_SUCCESS,
                target: this,
                targetName: this.name
            });
        }).catch((error) => {
            this?.logger?.log('loadUtag:', 'load utag Failure!', error);
            this.dispatchIFramePlayerEvent({
                type: IFramePlayerEvent.ON_ERROR,
                data: {
                    error: {
                        code: IFramePlayerErrorCode.P1000,
                        details: error,
                        fatal: IFramePlayerErrorFatal.P1000,
                        info: IFramePlayerErrorInfo.P1000
                    }
                },
                target: this,
                targetName: this.name
            });
        });
    };
    #loadSmartTag = () => {
        this.utils.Importer.import([IFramePlayerConstants.getInstance().smartTagImportVO], true).then((data) => {
            this?.logger?.log('loadSmartTag:', 'load Smart Tag success!', data);
            this.dispatchIFramePlayerEvent({
                type: IFramePlayerEvent.ON_SMART_TAG_IMPORT_SUCCESS,
                target: this,
                targetName: this.name
            });
        }).catch((error) => {
            this?.logger?.log('loadSmartTag:', 'load Smart Tag Failure!', error);
            this.dispatchIFramePlayerEvent({
                type: IFramePlayerEvent.ON_ERROR,
                data: {
                    error: {
                        code: IFramePlayerErrorCode.P1001,
                        details: error,
                        fatal: IFramePlayerErrorFatal.P1001,
                        info: IFramePlayerErrorInfo.P1001
                    }
                },
                target: this,
                targetName: this.name
            });
        });
    };
    #onAppEvent = (event) => {
        switch (event?.type) {
            case IFramePlayerEvent.ON_UTAG_IMPORT_REQUEST:
                this.#loadUtag();
                break;
            case IFramePlayerEvent.ON_SMART_TAG_IMPORT_REQUEST:
                this.#loadSmartTag();
                break;
        }
    };
}
